import { SpacingName, ThemedFunctor, getSpacing } from '@doveit/bricks';
import { css } from 'styled-components';

export const body: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.padding(theme, SpacingName.MEDIUM)}
  background: linear-gradient(to bottom, ${theme.palettes.neutrals.lighter} .5rem, ${theme.palettes.neutrals.lightest} 2rem);
`;
